import { ValidationError, validationErrorDecoder } from '@execonline-inc/resource';
import { Decoder, array, field } from 'jsonous';

export const validationErrorsDecoder: Decoder<{
  errors: ValidationError[];
}> = field('errors', array(validationErrorDecoder)).map((errors) => ({ errors }));
